const translation = {
  // ── Navigation & Topbar ──
  topbarNotice: 'Fièrement au service de Brampton et du GTA | Service 24/7',
  topbarCall: 'Appelez-nous : 416-817-4825',
  topbarGuaranteed: 'Entièrement assuré et satisfaction garantie',
  navHome: 'Accueil',
  navServices: 'Services',
  navAbout: 'Pourquoi Nous',
  navReviews: 'Avis Clients',
  navAreas: 'Zones de Service',
  navQuote: 'Obtenir un Devis',
  navContact: 'Contactez-Nous',
  navAllServices: 'Tous les Services',
  btnCallNow: 'Appeler le 416-817-4825',
  btnGetQuote: 'Obtenir un Devis Gratuit',

  // ── Hero ──
  heroBadge: 'Services de Nettoyage Familiaux de Confiance',
  heroTitle: 'Nettoyage Domiciliaire Impeccable à Brampton et GTA',
  heroSubhead: 'Équipes fiables, équipement professionnel et satisfaction garantie à chaque visite — demandez votre devis gratuit.',
  heroStatRating: 'Note de 5.0 (500+ Avis)',
  heroStatInsured: 'Entièrement Assuré et Cautionné',
  heroStatGuarantee: 'Satisfaction 100% Garantie',

  // ── Why Us ──
  whyUsLabel: 'Pourquoi Nous Choisir',
  whyUsTitle: 'Le nettoyage que vous méritez, bien fait.',
  whyUsSubtext: 'Nous ne sommes pas une simple entreprise de nettoyage — nous sommes une entreprise familiale locale qui traite chaque maison comme la nôtre. Voici ce qui nous distingue.',
  whyFamilyTitle: 'Entreprise Familiale',
  whyFamilyDesc: 'Commerce local fondé sur la confiance et l\'attention personnelle. Nous traitons chaque maison comme la nôtre, car notre réputation dans la communauté est primordiale.',
  whyReliableTitle: 'Fiable et Digne de Confiance',
  whyReliableDesc: 'Personnel vérifié, assuré et ponctuel. Chaque agent d\'entretien est rigoureusement sélectionné et formé pour offrir une qualité constante.',
  whyPricingTitle: 'Prix Abordables',
  whyPricingDesc: 'Tarifs justes et transparents — aucun frais caché. Vous saurez toujours exactement ce que vous payez avant que nous commencions.',
  whySatisfactionTitle: 'Satisfaction Garantie',
  whySatisfactionDesc: 'Pas satisfait ? Nous repassons sous 24h gratuitement. C\'est notre promesse à chaque client — sans poser de questions.',
  whyFlexibleTitle: 'Horaire Flexible',
  whyFlexibleDesc: 'Soirs, fins de semaine et réservations urgentes. Nous nous adaptons à votre vie bien remplie, pas l\'inverse.',
  whyProTitle: 'Équipement Professionnel',
  whyProDesc: 'Produits écologiques et outils professionnels HEPA. Sans danger pour votre famille, vos animaux et l\'environnement.',

  // ── Services ──
  servicesLabel: 'Nos Services',
  servicesTitle: 'Services de Nettoyage Que Nous Offrons',
  servicesSubtext: 'Des entretiens réguliers aux nettoyages approfondis complets — tout est couvert. Chaque service est accompagné de notre garantie de satisfaction.',
  serviceResidential: 'Nettoyage Résidentiel',
  serviceResidentialDesc: 'Nettoyage résidentiel régulier adapté à votre horaire — hebdomadaire, bihebdomadaire ou mensuel.',
  serviceDeep: 'Nettoyage en Profondeur',
  serviceDeepDesc: 'Nettoyage détaillé de haut en bas pour plinthes, électroménagers, joints et zones négligées.',
  serviceMove: 'Déménagement (Entrée / Sortie)',
  serviceMoveDesc: 'Laissez votre ancien logement impeccable ou emménagez dans un espace étincelant sans stress.',
  serviceOffice: 'Nettoyage de Bureaux',
  serviceOfficeDesc: 'Gardez votre espace de travail propre, sain et productif avec nos nettoyages programmés.',
  serviceAirbnb: 'Location Court Terme & Airbnb',
  serviceAirbnbDesc: 'Nettoyage rapide entre deux invités, incluant changement de draps et réapprovisionnement.',
  servicePostConstruction: 'Après Construction & Rénovation',
  servicePostConstructionDesc: 'Élimination des poussières fines, débris et résidus après travaux de rénovation ou construction.',
  serviceBtn: 'Demander un Devis',

  // ── Service Detail Pages ──
  serviceDetailBack: 'Retour aux Services',
  serviceDetailIncludes: 'Ce Qui Est Inclus',
  serviceDetailPricing: 'Tarification',
  serviceDetailProcess: 'Notre Processus',
  serviceDetailFaq: 'Questions Fréquentes',
  serviceDetailBookNow: 'Demander un Devis',
  serviceDetailStartingFrom: 'À partir de',
  serviceDetailCAD: 'CAD',
  serviceDetailLearnMore: 'En Savoir Plus',
  serviceDetailOverview: 'Aperçu',
  serviceDetailFreeQuote: 'Devis gratuit, sans obligation',
  serviceDetailQuoteNote: 'Chaque maison et entreprise est différente, donc nous établissons chaque devis individuellement. Partagez quelques détails sur votre espace et nous vous enverrons un prix juste et personnalisé — généralement sous 24 heures. Sans obligation, sans pression.',

  // ── Services Hub Page ──
  servicesHubTitle: 'Catalogue Complet de Services de Nettoyage',
  servicesHubSubtext: 'Explorez notre gamme complète de services de nettoyage professionnels. Chaque service est adapté à vos besoins spécifiques avec des prix transparents et notre garantie de satisfaction.',
  servicesHubFilterAll: 'Tous les Services',
  servicesHubFilterResidential: 'Résidentiel',
  servicesHubFilterCommercial: 'Commercial',
  servicesHubFilterSpecialty: 'Spécialisé',
  servicesHubStartingAt: 'À partir de',
  servicesHubViewDetails: 'Voir Détails',
  servicesHubCtaBanner: 'Pas sûr du service dont vous avez besoin ? Obtenez une consultation gratuite et nous vous aiderons à choisir.',
  servicesHubCtaBtn: 'Consultation Gratuite',

  // ── Reviews ──
  reviewsLabel: 'Témoignages',
  reviewsTitle: 'Adoré par les Propriétaires du GTA',
  reviewsSubtext: 'Des retours authentiques de vrais clients — découvrez pourquoi Brampton et les environs font confiance à AL Cleaning Pro.',
  reviewsBtn: 'Laisser un Avis',
  reviewsPageTitle: 'Avis Clients et Témoignages',
  reviewsPageSubtext: 'Note moyenne de 5.0 sur plus de 500 avis vérifiés de propriétaires et d\'entreprises à travers le Grand Toronto.',
  reviewsFilterAll: 'Tous les Avis',
  reviewsFilterResidential: 'Résidentiel',
  reviewsFilterDeep: 'Nettoyage Profond',
  reviewsFilterMove: 'Déménagement',
  reviewsFilterOffice: 'Bureau',
  reviewsFilterAirbnb: 'Airbnb',
  reviewsFilterConstruction: 'Après-Construction',
  reviewsVerifiedBadge: 'Client Vérifié',
  reviewsAverageRating: 'Note Moyenne',
  reviewsTotalReviews: 'Total des Avis',
  reviewModalTitle: 'Partagez Votre Expérience',
  reviewModalName: 'Votre Nom',
  reviewModalLocation: 'Votre Ville',
  reviewModalService: 'Service Reçu',
  reviewModalRating: 'Votre Note',
  reviewModalText: 'Votre Avis',
  reviewModalSubmit: 'Soumettre l\'Avis',
  reviewModalClose: 'Fermer',
  reviewModalSuccess: 'Merci pour votre avis ! Il apparaîtra bientôt sur le site.',
  reviewPrev: 'Avis précédent',
  reviewNext: 'Avis suivant',

  // ── About Page ──
  aboutLabel: 'À Propos',
  aboutTitle: 'L\'Histoire d\'AL Cleaning Pro',
  aboutSubtext: 'D\'un petit rêve familial à l\'un des services de nettoyage les plus fiables du GTA — voici notre parcours.',
  aboutStoryTitle: 'Notre Parcours',
  aboutStoryP1: 'AL Cleaning Pro a été fondée à Brampton, en Ontario, avec une mission simple : fournir des services de nettoyage honnêtes, fiables et minutieux auxquels les familles du Grand Toronto peuvent faire confiance. Ce qui a commencé comme une petite entreprise familiale est devenu l\'une des entreprises de nettoyage les plus respectées de la région, servant des centaines de propriétaires et d\'entreprises satisfaits chaque mois.',
  aboutStoryP2: 'En tant qu\'entreprise familiale, nous comprenons l\'importance d\'une maison propre et saine. Chaque membre de notre équipe est traité comme une famille, et chaque maison que nous nettoyons est traitée comme la nôtre. Nous ne négligeons aucun détail.',
  aboutStoryP3: 'Aujourd\'hui, AL Cleaning Pro dessert fièrement Brampton, Mississauga, Toronto, Vaughan, Caledon, Milton, Georgetown et tout le GTA avec une équipe croissante de nettoyeurs professionnels vérifiés et un engagement d\'excellence qui ne faiblit jamais.',
  aboutValuesTitle: 'Nos Valeurs Fondamentales',
  aboutValueSafetyTitle: 'La Sécurité d\'Abord',
  aboutValueSafetyDesc: 'Chaque membre de l\'équipe fait l\'objet de vérifications approfondies et est entièrement assuré et cautionné. Nous utilisons des produits de nettoyage non toxiques et écologiques, sans danger pour les enfants, les animaux et l\'environnement.',
  aboutValueEcoTitle: 'Engagement Écologique',
  aboutValueEcoDesc: 'Nous utilisons exclusivement des solutions de nettoyage biodégradables sans phosphate et des aspirateurs à filtration HEPA qui capturent 99,97% des particules en suspension. Meilleur pour votre maison, meilleur pour la planète.',
  aboutValueTeamTitle: 'Professionnels Vérifiés',
  aboutValueTeamDesc: 'Nos équipes de nettoyage sont soigneusement sélectionnées, formées en profondeur et évaluées en continu. Chaque nettoyeur porte une pièce d\'identité complète et arrive en uniforme d\'entreprise. La constance et le professionnalisme sont nos normes.',
  aboutValueGuaranteeTitle: 'Garantie de Re-Nettoyage sous 24h',
  aboutValueGuaranteeDesc: 'Si vous n\'êtes pas entièrement satisfait d\'une zone que nous avons nettoyée, appelez-nous dans les 24 heures et nous reviendrons la nettoyer sans frais supplémentaires. Aucune question posée. C\'est notre promesse.',
  aboutOwnerTitle: 'Supervision Familiale Directe',
  aboutOwnerText: 'Contrairement aux grandes franchises où vous ne rencontrez jamais le propriétaire, AL Cleaning Pro maintient une supervision familiale directe sur chaque travail important. Nous inspectons personnellement la qualité et veillons à ce que chaque client soit ravi des résultats.',
  aboutCtaText: 'Découvrez la différence d\'un service de nettoyage familial. Appelez-nous ou demandez votre devis gratuit dès aujourd\'hui.',

  // ── Service Areas ──
  areasLabel: 'Couverture',
  areasTitle: 'Zones de Service — Fièrement au Service du GTA',
  areasSubtext: 'Basés à Brampton, nous nettoyons les maisons et bureaux dans tout le Grand Toronto. Nos équipes mobiles couvrent toute la région.',
  areaBrampton: 'Brampton',
  areaBramptonDesc: 'Siège Principal',
  areaMississauga: 'Mississauga',
  areaMississaugaDesc: 'Couverture Complète',
  areaToronto: 'Toronto',
  areaTorontoDesc: 'Centre-ville et Région',
  areaVaughan: 'Vaughan',
  areaVaughanDesc: 'Couverture Complète',
  areaCaledon: 'Caledon',
  areaCaledonDesc: 'Couverture Complète',
  areaMilton: 'Milton',
  areaMiltonDesc: 'Couverture Complète',
  areaGeorgetown: 'Georgetown',
  areaGeorgetownDesc: 'Couverture Complète',

  // ── Area City Pages ──
  areaCityBack: 'Retour aux Zones',
  areaCityNeighborhoods: 'Quartiers Desservis',
  areaCityCoverageMap: 'Carte de Couverture',
  areaCityBookingCta: 'Réservez un nettoyage à',
  areaCityBookNow: 'Obtenez un Devis pour',
  areaCityTrustedBy: 'Approuvé par des centaines de familles à',
  areaCityDescBrampton: 'AL Cleaning Pro a son siège à Brampton et offre des services complets de nettoyage résidentiel et de bureau dans tous les quartiers de Brampton, y compris Downtown Brampton, Bramalea, Heart Lake, Mount Pleasant, Springdale et Fletcher\'s Creek.',
  areaCityDescMississauga: 'AL Cleaning Pro fournit des services de nettoyage résidentiel et de bureau de premier ordre à Mississauga, incluant Square One, Port Credit, Streetsville, Erin Mills, Meadowvale et Clarkson.',
  areaCityDescToronto: 'AL Cleaning Pro dessert le centre-ville de Toronto et le GTA avec des services fiables de nettoyage résidentiel, de bureau et spécialisé. Nos équipes mobiles couvrent Etobicoke, North York, Scarborough et le centre-ville.',
  areaCityDescVaughan: 'AL Cleaning Pro offre des services de nettoyage résidentiel et de bureau haut de gamme à Vaughan, desservant Woodbridge, Maple, Kleinburg, Concord et Thornhill.',
  areaCityDescCaledon: 'AL Cleaning Pro dessert Caledon et les environs, y compris Bolton, Palgrave, Caledon East et les propriétés rurales avec des services de nettoyage spécialisés.',
  areaCityDescMilton: 'AL Cleaning Pro fournit un nettoyage rapide et fiable à Milton — couvrant toute la ville, y compris Milton Heights, Campbellville et tous les nouveaux développements résidentiels.',
  areaCityDescGeorgetown: 'AL Cleaning Pro offre des services de nettoyage de confiance à Georgetown et Halton Hills, couvrant les quartiers résidentiels et les propriétés commerciales.',

  // ── Quote Engine ──
  quoteLabel: 'Demander un Devis',
  quoteTitle: 'Demandez Votre Devis Gratuit',
  quoteSubtext: 'Partagez quelques détails sur vos besoins de nettoyage et choisissez comment nous devons vous joindre. Nous examinerons et répondrons avec un devis juste et sans obligation.',
  quoteGuarantee1: 'Sans obligation — 100% Gratuit',
  quoteGuarantee2: 'Réponse sous 24 heures',
  quoteGuarantee3: 'Planification flexible la même semaine',
  quoteGuarantee4: 'Satisfaction garantie',
  quoteStep1: 'Coordonnées',
  quoteFullName: 'Nom Complet',
  quotePhone: 'Numéro de Téléphone',
  quoteEmail: 'Adresse Courriel',
  quoteAddress: 'Adresse et Ville',
  quoteStep2: 'Détails de la Propriété et du Service',
  quoteServiceLabel: 'Service Souhaité',
  quoteBedrooms: 'Chambres',
  quoteBathrooms: 'Salles de Bain',
  quoteSqft: 'Pieds Carrés Approximatifs',
  quoteFrequency: 'Fréquence',
  quoteOneTime: 'Une Fois',
  quoteWeekly: 'Hebdomadaire',
  quoteBiWeekly: 'Bihebdomadaire',
  quoteMonthly: 'Mensuel',
  quoteDate: 'Date de Nettoyage Préférée',
  quoteNotes: 'Notes / Instructions Spéciales',
  quoteNotesPlaceholder: 'Que souhaitez-vous que nous fassions ? Des zones spécifiques à cibler ?',
  quoteSubtotal: 'Sous-total',
  quoteDiscount: 'Remise de Fréquence',
  quoteTax: 'TVH (13%)',
  quoteTotal: 'Total Estimé',
  quoteOptionA: 'Demander mon Devis Gratuit',
  quoteOptionB: 'Réserver et Payer en Ligne',
  quoteOptionADesc: 'Soumettez vos coordonnées et nous vous répondrons avec un devis personnalisé sous 24 heures.',
  quoteOptionBDesc: 'Confirmez votre réservation instantanément en payant en ligne par carte, Apple Pay, Google Pay ou virement Interac.',
  quoteSelectService: 'Sélectionnez un service',
  quoteSelectBedrooms: 'Sélectionnez les chambres',
  quoteSelectBathrooms: 'Sélectionnez les salles de bain',
  quoteSelectFrequency: 'Sélectionnez la fréquence',
  quoteNameRequired: 'Veuillez entrer votre nom complet.',
  quotePhoneRequired: 'Veuillez entrer votre numéro de téléphone.',
  quoteEmailRequired: 'Veuillez entrer votre adresse courriel.',
  quoteServiceRequired: 'Veuillez sélectionner un service.',
  quoteSuccess: 'Votre demande de devis a été soumise ! Nous vous contacterons sous 24 heures.',
  quoteReferenceId: 'Référence',
  quoteClose: 'Fermer',
  quoteMsgGreeting: "Bonjour AL Cleaning Pro ! J'aimerais demander un devis gratuit pour un service de nettoyage.",
  quoteEmailSubject: 'Nouvelle Demande de Devis de Nettoyage',
  quoteChannelTitle: 'Choisissez Comment Envoyer Votre Demande',
  quoteChannelHint: 'Choisissez l\'option la plus simple pour vous — vos détails s\'ouvriront pré-remplis dans l\'application de votre choix.',
  quoteChannelWhatsApp: 'Envoyer via WhatsApp',
  quoteChannelSMS: 'Envoyer par SMS / Texto',
  quoteChannelEmail: 'Envoyer par Courriel',
  quoteChannelWhatsAppSub: 'Le plus rapide — recevez une réponse sur WhatsApp',
  quoteChannelSMSSub: 'Ouvre votre application de messagerie',
  quoteChannelEmailSub: 'Ouvre votre application de courriel, prêt à envoyer',

  // ── Booking ──
  bookingLabel: 'Réservation en Ligne',
  bookingTitle: 'Choisissez un Horaire et Réservez',
  bookingSubtext: 'Utilisez le calendrier ci-dessous pour choisir votre service, sélectionner un créneau disponible et réserver votre nettoyage — la confirmation arrive directement dans votre boîte courriel.',
  bookingHowTitle: 'Comment Réserver',
  bookingStep1Title: 'Choisissez Votre Créneau',
  bookingStep1Desc: 'Sélectionnez le service et l\'heure qui vous conviennent sur le calendrier.',
  bookingStep2Title: 'Ajoutez Vos Coordonnées',
  bookingStep2Desc: 'Indiquez votre nom, vos coordonnées et votre adresse pour que nous arrivions préparés.',
  bookingStep3Title: 'Confirmation Instantanée',
  bookingStep3Desc: 'Votre rendez-vous est confirmé par courriel et synchronisé à notre calendrier.',
  bookingNoteTitle: 'Jamais de Double Réservation',
  bookingNoteDesc: 'Notre calendrier se met à jour en temps réel — une fois votre créneau réservé, il est bloqué pour les autres.',
  bookingEmailLabel: 'Confirmation et Avis',
  bookingEmailValue: 'Envoyés à votre courriel instantanément après la réservation.',
  bookingLoading: 'Chargement du calendrier de réservation…',

  // ── Contact Page ──
  contactPageTitle: 'Contactez-Nous',
  contactPageSubtext: 'Des questions ou prêt à réserver ? Contactez-nous — nous sommes disponibles 24h/24 et 7j/7.',
  contactFormTitle: 'Envoyez-Nous un Message',
  contactFormName: 'Votre Nom',
  contactFormEmail: 'Adresse Courriel',
  contactFormPhone: 'Numéro de Téléphone',
  contactFormSubject: 'Sujet',
  contactFormMessage: 'Votre Message',
  contactFormSubmit: 'Envoyer le Message',
  contactFormSuccessTitle: 'Message Envoyé !',
  contactFormSuccessText: 'Merci de nous avoir contactés. Nous vous répondrons dans les 24 heures.',
  contactFormError: 'Une erreur est survenue. Veuillez réessayer ou appelez-nous directement.',
  contactInfoTitle: 'Coordonnées',
  contactPhoneLabel: 'Téléphone',
  contactEmailLabel: 'Courriel',
  contactAddressLabel: 'Adresse',
  contactHoursLabel: 'Heures d\'Ouverture',
  contactHoursValue: 'Ouvert 24 Heures / 7 Jours par Semaine',
  contactMapTitle: 'Notre Emplacement',

  // ── Checkout Modal ──
  checkoutTitle: 'Réserver et Payer en Ligne',
  checkoutSubtext: 'Sécurisez votre réservation instantanément. Choisissez votre mode de paiement ci-dessous.',
  checkoutDeposit: 'Payer l\'Acompte (50 $ CAD)',
  checkoutFullAmount: 'Payer le Montant Total',
  checkoutStripeTab: 'Carte de Crédit / Apple Pay',
  checkoutInteracTab: 'Virement Interac',
  checkoutStripeDesc: 'Payez en toute sécurité avec Visa, Mastercard, AMEX, Apple Pay ou Google Pay.',
  checkoutInteracDesc: 'Envoyez votre paiement par virement Interac en utilisant les informations ci-dessous.',
  checkoutInteracEmail: 'Envoyer le virement à',
  checkoutInteracMemo: 'Note / Référence',
  checkoutInteracNote: 'Veuillez inclure votre référence de réservation dans la note du virement Interac. Votre rendez-vous sera confirmé dès réception du paiement.',
  checkoutPayNow: 'Payer Maintenant',
  checkoutProcessing: 'Traitement en cours...',
  checkoutAmount: 'Montant',
  checkoutBookingRef: 'Référence de Réservation',
  checkoutCancel: 'Annuler',

  // ── Home Page Sections ──
  homeServicesPreviewTitle: 'Nos Services de Nettoyage',
  homeServicesPreviewLink: 'Voir Tous les Services',
  homeReviewsPreviewTitle: 'Ce Que Disent Nos Clients',
  homeReviewsPreviewLink: 'Lire Tous les Avis',
  homeAreasPreviewTitle: 'Desservant le GTA',
  homeAreasPreviewLink: 'Voir Toutes les Zones',
  homeCtaTitle: 'Prêt pour un espace impeccable ?',
  homeCtaSubtext: 'Obtenez votre devis gratuit sans obligation en moins de 60 secondes. Réservations disponibles la même semaine.',

  // ── Our Work Gallery ──
  ourWorkLabel: 'Nos Réalisations Récentes',
  ourWorkTitle: 'Découvrez la Différence AL Cleaning Pro',
  ourWorkSubtext: 'Parcourez quelques-uns de nos projets de nettoyage récents à travers le GTA. De vrais résultats, de vraies transformations — du désordre à l\'impeccable.',
  ourWorkViewMore: 'Voir la Galerie Complète',
  ourWorkBefore: 'Avant',
  ourWorkAfter: 'Après',
  ourWorkCategoryResidential: 'Nettoyage Résidentiel',
  ourWorkCategoryDeep: 'Nettoyage en Profondeur',
  ourWorkCategoryMove: 'Nettoyage Déménagement',
  ourWorkCategoryOffice: 'Nettoyage de Bureau',
  ourWorkCategoryAirbnb: 'Rotation Airbnb',
  ourWorkCategoryConstruction: 'Après-Construction',

  // ── Home Page Section: Our Work ──
  homeOurWorkTitle: 'Nos Réalisations Récentes',
  homeOurWorkSubtext: 'De vrais résultats dans de vraies maisons et entreprises du GTA. Voici à quoi ressemble un nettoyage professionnel.',

  // ── Footer ──
  footerCtaTitle: 'Prêt pour un espace impeccable ?',
  footerCtaSubtext: 'Appelez ou écrivez-nous dès aujourd\'hui pour un devis gratuit sans obligation. Planification flexible — réservations disponibles la même semaine.',
  footerCall: 'Appeler',
  footerEmail: 'Écrivez-Nous',
  footerQuickLinks: 'Liens Rapides',
  footerOurServices: 'Nos Services',
  footerContactUs: 'Contactez-Nous',
  footerBrandDesc: 'Services de nettoyage familiaux à Brampton et dans le GTA. Satisfaction garantie à chaque visite.',
  footerFollowUs: 'Suivez-Nous',
  footerLegal: '© 2026 AL Cleaning Pro. Tous droits réservés.',
  footerInsured: 'Entreprise Familiale Entièrement Assurée et Cautionnée',

  // ── WhatsApp / SMS ──
  whatsappChat: 'Discuter sur WhatsApp',
  topbarWhatsApp: 'WhatsApp',
  smsBtn: 'Envoyer un SMS',
  smsBody: "Bonjour AL Cleaning Pro ! J'aimerais demander un devis gratuit pour un service de nettoyage.",
  contactQuickTitle: 'Les Moyens les Plus Rapides de Nous Joindre',

  // ── Common ──
  langEnglish: 'English',
  langFrench: 'Français',
  switchLang: 'Passer en Anglais',
  loading: 'Chargement...',
  pageNotFound: 'Page Introuvable',
  pageNotFoundDesc: 'La page que vous cherchez n\'existe pas.',
  backToHome: 'Retour à l\'Accueil',
};

export default translation;